
export enum OrderState {
  WAITING = 'WAITING',
  ACCEPTED = 'ACCEPTED',
  UNACCEPTED = 'UNACCEPTED',
  ON_THE_MOVE = 'ON_THE_MOVE',
  DELIVERED = 'DELIVERED',
  UNDELIVERED = 'UNDELIVERED',
  IN_PROGRESS = 'IN_PROGRESS',
  POS_ENTERED = 'POS_ENTERED',
  CANCELLED = 'CANCELLED'
}